<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="card card-flush h-lg-100 mw-900px mx-auto">
        <div class="card-header pt-7">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold fs-3 mb-1 text-white">{{
              "assessment.title" | translate
            }}</span>
          </h3>
        </div>

        <div class="card-body">
          <ul class="nav nav-tabs nav-line-tabs mb-5 fs-6">
            <li class="nav-item">
              <a
                class="nav-link cursor-pointer"
                [class.active]="activeTab === 0"
                (click)="setActiveTab(0)"
              >
                {{ "assessment.noWound" | translate }}
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link cursor-pointer"
                [class.active]="activeTab === 1"
                (click)="setActiveTab(1)"
              >
                {{ "assessment.hasWound" | translate }}
              </a>
            </li>
          </ul>

          <div *ngIf="isLoading" class="d-flex justify-content-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div class="alert alert-danger" *ngIf="loadError">
            {{ loadError }}
          </div>

          <form
            *ngIf="!isLoading && !loadError && questions?.length"
            (ngSubmit)="onSubmit()"
          >
            <div class="d-flex flex-column gap-5">
              <div
                class="accordion"
                id="assessmentAccordion"
                *ngFor="let group of questionGroups; let i = index"
              >
                <div class="accordion-item">
                  <h2 class="accordion-header" [id]="'heading-' + i">
                    <button
                      class="accordion-button fw-bold fs-4"
                      [class.collapsed]="!group.isOpen"
                      type="button"
                      (click)="group.isOpen = !group.isOpen"
                    >
                      {{ getDisplayGroupTitle(group) }}
                    </button>
                  </h2>
                  <div
                    [id]="'collapse-' + i"
                    class="accordion-collapse collapse"
                    [class.show]="group.isOpen"
                  >
                    <div class="accordion-body">
                      <div class="d-flex flex-column gap-5">
                        <div
                          class="disabled-question-wrapper position-relative"
                          [class.is-disabled]="q.isDisabled"
                          *ngFor="
                            let q of group.questions;
                            trackBy: trackByQuestionId
                          "
                        >
                          <div class="disabled-tooltip" *ngIf="q.isDisabled">
                            {{ q.disabledReason | translate }}
                          </div>
                          <div
                            class="card border border-dashed border-gray-300"
                            [class.disabled-question]="q.isDisabled"
                          >
                            <div class="card-body p-5">
                              <div
                                class="d-flex justify-content-between align-items-start mb-4"
                              >
                                <div class="fw-bold fs-5 text-white">
                                  {{ getDisplayQuestionText(q.text) }}
                                </div>

                                <div class="d-flex gap-2">
                                  <span
                                    class="badge badge-light-secondary"
                                    *ngIf="q.isDisabled"
                                    >{{
                                      "assessment.disabled" | translate
                                    }}</span
                                  >
                                  <span
                                    class="badge badge-light-danger"
                                    *ngIf="q.isRequired && !q.isDisabled"
                                    >{{
                                      "assessment.required" | translate
                                    }}</span
                                  >
                                </div>
                              </div>

                              <div class="d-flex flex-column gap-3">
                                <label
                                  class="d-flex align-items-center form-check form-check-custom form-check-solid p-3 border border-gray-600 border-hover-primary rounded hover-elevate-up bg-hover-white-5 transition-all"
                                  [class.cursor-pointer]="!q.isDisabled"
                                  [class.cursor-not-allowed]="q.isDisabled"
                                  [class.selected-option]="
                                    q.answerOptionId === opt.id
                                  "
                                  *ngFor="let opt of q.options"
                                  (click)="onOptionClick(q, opt.id, $event)"
                                  (mouseenter)="
                                    showTooltip($event, opt.tooltip || '')
                                  "
                                  (mousemove)="updateTooltipPosition($event)"
                                  (mouseleave)="hideTooltip()"
                                >
                                  <input
                                    class="form-check-input me-3 border-gray-600"
                                    type="radio"
                                    [name]="'q-' + q.id"
                                    [value]="opt.id"
                                    [checked]="q.answerOptionId === opt.id"
                                    [disabled]="q.isDisabled"
                                  />
                                  <div
                                    class="d-flex justify-content-between w-100"
                                  >
                                    <span
                                      class="fw-bold"
                                      [class.text-white]="
                                        q.answerOptionId === opt.id
                                      "
                                      [class.text-gray-800]="
                                        q.answerOptionId !== opt.id
                                      "
                                      >{{ getDisplayOptionText(opt.text) }}</span
                                    >
                                    <span
                                      class="fs-7 fw-semibold"
                                      [class.text-gray-300]="
                                        q.answerOptionId === opt.id
                                      "
                                      [class.text-gray-500]="
                                        q.answerOptionId !== opt.id
                                      "
                                      >{{ "assessment.score" | translate }}:
                                      {{ opt.score }}</span
                                    >
                                  </div>
                                </label>
                              </div>

                              <div
                                class="text-danger fs-7 mt-2"
                                *ngIf="
                                  q.touched &&
                                  q.isRequired &&
                                  !q.answerOptionId &&
                                  !q.isDisabled
                                "
                              >
                                {{
                                  "assessment.questionRequiredError" | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Custom tooltip element -->
            <div
              class="risk-tooltip"
              *ngIf="activeTooltip"
              [style.left.px]="activeTooltip.x"
              [style.top.px]="activeTooltip.y"
            >
              {{ activeTooltip.text }}
            </div>

            <div class="mt-8">
              <div class="alert alert-danger mb-4" *ngIf="submitError">
                {{ submitError }}
              </div>

              <div class="d-flex gap-3">
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="isSubmitting"
                >
                  <span *ngIf="!isSubmitting">{{
                    "assessment.submitAndCalculate" | translate
                  }}</span>
                  <span *ngIf="isSubmitting">
                    <span
                      class="spinner-border spinner-border-sm align-middle me-2"
                    ></span>
                    {{ "assessment.submitting" | translate }}
                  </span>
                </button>

                <button
                  type="button"
                  class="btn btn-light"
                  (click)="resetAnswers()"
                  [disabled]="isSubmitting || !hasAnyAnswer"
                  *ngIf="hasAnyAnswer"
                >
                  {{ "assessment.resetAnswers" | translate }}
                </button>
              </div>
            </div>
          </form>

          <div
            class="alert alert-info d-flex align-items-center p-5 mb-10"
            *ngIf="
              !isLoading && !loadError && (!questions || !questions.length)
            "
          >
            <i class="fa-solid fa-circle-info fs-2hx text-info me-4"></i>
            <div class="d-flex flex-column">
              <h4 class="mb-1 text-info">
                {{ "assessment.info" | translate }}
              </h4>
              <span>{{ "assessment.noQuestions" | translate }}</span>
            </div>
          </div>

          <div class="mt-10" *ngIf="scores && scores.length">
            <div class="separator separator-dashed border-gray-600 my-8"></div>
            <h3 class="fw-bold text-white mb-5">
              {{ "assessment.resultsTitle" | translate }}
            </h3>

            <div class="row g-5">
              <div class="col-12 col-md-6" *ngFor="let s of scores">
                <div class="card card-flush h-100 border border-gray-700">
                  <div class="card-header pt-5">
                    <div class="card-title d-flex flex-column">
                      <span class="fs-2hx fw-bold text-white me-2 lh-1 ls-n2">{{
                        s.totalScore
                      }}</span>
                      <span class="text-gray-400 pt-1 fw-semibold fs-6">{{
                        "assessment.totalScore" | translate
                      }}</span>
                    </div>
                    <div class="card-toolbar">
                      <span
                        class="badge badge-light-primary fs-7 fw-bold text-wrap text-start mw-100"
                        >{{ getDisplayAssessmentCode(s.assessmentTemplateCode) }}</span
                      >
                    </div>
                  </div>
                  <div class="card-body pt-2 pb-5">
                    <div class="d-flex align-items-center mb-2">
                      <span class="text-gray-300 fw-bold fs-6"
                        >{{ "assessment.riskCategory" | translate }}:</span
                      >
                      <span class="ms-2 badge badge-light-warning fw-bold">{{
                        s.riskCategoryName
                      }}</span>
                    </div>
                    <span class="text-gray-400 fw-semibold fs-6">{{
                      s.description
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
